import { useCallback, useEffect, useState } from 'react';
import { usePortalCmsRefresh } from '../../context/RealtimeSyncContext';

const API = process.env.REACT_APP_API_BASE_URL;

export const ACCOUNT_PORTAL_SLUGS = {
  settings: 'account-settings',
  profile: 'account-profile',
  invoice: 'account-invoice',
  paymentHistory: 'account-payment-history',
};

const fetchPage = async (slug) => {
  const response = await fetch(`${API}/api/portal-cms/page/${slug}`);
  if (!response.ok) throw new Error(`Failed to load ${slug}`);
  const data = await response.json();
  return data.data || null;
};

export const useAccountPortal = () => {
  const [settings, setSettings] = useState(null);
  const [profile, setProfile] = useState(null);
  const [invoice, setInvoice] = useState(null);
  const [paymentHistory, setPaymentHistory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [settingsData, profileData, invoiceData, paymentData] = await Promise.all([
        fetchPage(ACCOUNT_PORTAL_SLUGS.settings),
        fetchPage(ACCOUNT_PORTAL_SLUGS.profile),
        fetchPage(ACCOUNT_PORTAL_SLUGS.invoice),
        fetchPage(ACCOUNT_PORTAL_SLUGS.paymentHistory),
      ]);
      setSettings(settingsData);
      setProfile(profileData);
      setInvoice(invoiceData);
      setPaymentHistory(paymentData);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  usePortalCmsRefresh(Object.values(ACCOUNT_PORTAL_SLUGS), load);

  return {
    settings,
    profile,
    invoice,
    paymentHistory,
    loading,
    error,
    refresh: load,
  };
};
